import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousand',
})
export class ThousandPipe implements PipeTransform {
  transform(value) {
    let number = 0;
    if (value) {
      number = value.toLocaleString();
    }
    return number;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/thousand/thousand.ts